import { InvoiceDetailScreen, InvoiceDetailScreenBreadcrumb } from "./screens/InvoiceDetailScreen";
import { InvoicesListScreen } from "./screens/InvoicesListScreen";

export const invoicesRoutes = [
    {
        path: "invoices",
        handle: { breadcrumb: "invoice:list.title" },
        children: [
            { index: true, element: <InvoicesListScreen /> },
            {
                path: ":invoiceId",
                handle: { breadcrumb: InvoiceDetailScreenBreadcrumb },
                element: <InvoiceDetailScreen />,
            },
        ],
    },
];
